import styled from 'styled-components'

export const Container = styled.div`
  margin: auto;
  max-width: 100%;
  border-radius: 15px;
  justify-content: center;
  background-color: #1C1C1C;
  align-items: center !important;
`

export const Header = styled.div`
  flex: 1;
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0px;
  padding: 10px 2vw 10px;
  background-color: #1C1C1C;
  z-index: 999;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 30px;
  padding: 30px;
  background-color: ${({ bgColor }) => bgColor || '#272727'};
  gap: 20px;
  
  h2, p { text-align: center; }

  @media (max-width: 800px) {
    padding: 20px;
  }
`

export const InnerContainer = styled(InfoContainer)`
  width: 100%;
  height: 100%;
  justify-content: center;
  border-radius: 15px;
  background-color: ${({ bgColor }) => bgColor || '#FFC100'};
`

export const BigInfoContainer = styled.div`
  width: 80vw;
  min-width: 30vw;
  background: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 30px;
  padding: 30px;
  gap: 30px;

  h2, p { text-align: center; }

  @media (max-width: 800px) {
    width: 100%;
    flex-direction: column;
    justify-content: center;

    div { flex-direction: column; align-items: center; }
  }
`

export const Section = styled.div`
  background-color: #1C1C1C;
  padding: 0vh 2vw 2vh 2vw;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  gap: 20px;

  > h2, > p {
    max-width: 60%;
    text-align: center;
    margin: 0px 20px;
  }

  > p {
    max-width: 50%;
  }

  @media (max-width: 800px) {
    padding: 0px 20px 20px;

    > h2, > p {
      max-width: 100%;
    }
  }
`

export const Banner = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 85px;
  padding: 0px 80px;
  border-radius: 30px;
  background-color: #000000;

  h2, p { text-align: left; }

  @media (max-width: 900px) {
    flex-direction: column-reverse;
    justify-content: center;
    padding: 30px;

    h2, p { text-align: center; }
    div { align-items: center; }
  }
`

export const ItemGrid = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-top: 10px;
  gap: 30px;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const Footer = styled.div`
  display: flex;
  background-color: #1C1C1C;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 10px;
  gap: 40px;
`

export const FooterLine = styled.div`
  width: 80vw;
  height: 1px;
  background-color: #FFFFFF23;
  justify-self: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${({ gap }) => gap || 30}px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;

  @media (max-width: 500px) {
    flex-direction: ${({ columnOnMobile }) => columnOnMobile ? 'column' : 'row'};
  }
`

export const ItemRow = styled(Row)`
  gap: 12px;

  p {
    font-size: ${({ fontSize }) => fontSize || 16}px;
    text-align: left;
  }
`

export const IconCircle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme === 'dark' ? '#FFFFFF32' : '#0000001A'};
  border-radius: 50%;
  padding: 7px;
`

export const SmallImage = styled.img`
  width: 5vh;
  border-radius: 100px;
`

export const Logo = styled.img`
  height: ${({ height }) => height || 30}px;
  margin-right: 5px;
`

export const SmallLogoImg = styled.img`
  height: 18px;
`

export const HeroImage = styled.img`
  width: 42vw;
  height: 42vw;

  @media (max-width: 900px) {
    width: 300px;
    height: auto;
  }
`

export const Title = styled.h2`
  font-size: 3vw;
  font-weight: 400;
  text-align: left;
  color: ${({ color }) => color || '#FFFFFF'};
  font-family: 'Outfit';
  margin-bottom: -5px;

  span {
    color: #FFC100;
    font-size: 3vw;
    font-weight: 400;
    text-align: left;
  }

  @media (max-width: 800px) {
    font-size: 28px;
    text-align: center;

    span {
      font-size: 28px;
      text-align: center;
    }
  }
`

export const SubTitle = styled.p`
  color: ${({ color }) => color || '#F7F7F7'};
  font-size: ${({ fontSize }) => fontSize || 24}px;
  font-family: 'Outfit';
  font-weight: 300;
  text-align: left;
  margin: 0px;

  span {
    color: ${({ color }) => color && color ===  '#F7F7F7' ? '#FFC100' : '#FFFFFF'};
    font-size: ${({ fontSize }) => fontSize || 24}px;
    font-weight: 400;
  }

  @media (max-width: 1366px) {
    font-size: ${({ fontSize }) => fontSize || 18}px;
    span { font-size: ${({ fontSize }) => fontSize || 18}px; }
  }

  @media (max-width: 1920px) {
    font-size: ${({ fontSize }) => fontSize || 20}px;
    span { font-size: ${({ fontSize }) => fontSize || 20}px; }
  }
`

export const NumberText = styled(Title)`
  color: ${({ color }) => color || '#000000'};
  font-size: 6vw;
  line-height: 6vw;
  text-align: center;

  @media (max-width: 800px) {
    font-size: 6vh;
    line-height: 6vh;
    text-align: center;
  }
`

export const Button = styled.button`
  min-width: ${({ width }) => width || 140}px;
  height: ${({ height }) => height || 50}px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  font-size: 18px;
  font-family: 'Outfit';
  text-decoration: none;
  padding: 0px 20px;
  border: 0px;
  border-radius: 25px;
  transition: opacity 0.2s;
  background: linear-gradient(to right, #FFC100, #FF9800);

  &:hover { opacity: 0.7; }
  &:active { border: 0px; }

  @media (max-width: 900px) {
    display: ${({ hideOnMobile }) => hideOnMobile ? 'none' : 'flex'};
  }
`

export const IconLink = styled.a`
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border-radius: 99px;
  background-color: transparent;
  transition: background-color 0.2s;

  &:hover {
    background-color: #525252;
  }

  &:active { border: none; }
`

export const LinkButton = styled.a`
  width: ${({ width }) => width || 220}px;
  height: ${({ height }) => height || 50}px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: 'Outfit';
  text-decoration: none;
  padding: 0px 20px 1px;
  border: 0px;
  border-radius: 25px;
  color: #FFFFFF;
  background-color: #272727;
  transition: opacity 0.2s;
  gap: 10px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center; 
    gap: 0px; 
  }

  &:hover { opacity: 0.7; }
  &:active { border: 0px; }
`

export const LinkShortcut = styled.a`
  color: #F7F7F7;
  font-size: 18px;
  padding: 8px 20px;
  border-radius: 15px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-family: 'Outfit';
  transition: font-weight 0.2s, color 0.2s;

  &:hover {
    font-weight: 500;
    color: #FFC100;
  }

  @media (max-width: 767px) {
    display: ${({ hideOnMobile }) => hideOnMobile ? 'none' : 'flex'};
  }
`

export const Label = styled.p`
  font-size: 20px;
  color: #F7F7F7;
  margin-bottom: 5px;
  text-align: center;
  font-family: 'Outfit';
  font-weight: 400;

  span {
    color: #FFC100;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 5px;
  }
`

export const SmallTitle = styled.p`
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 5px;
  text-align: center;
  font-family: 'Outfit';
  color: #F7F7F7;

  @media (max-width: 500px) {
    font-size: 26px;
  }
`

export const MoneyText = styled.p`
  width: ${({ width }) => width || 170}px;
  height: ${({ height }) => height || 44}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #000000;
  background-color: #FFC100;
  font-size: ${({ fontSize }) => fontSize || 20}px;
  font-weight: 500;
  font-family: 'Outfit';
  text-align: center;
  border-radius: 50px;
  margin: 0px;
  gap: 5px;
`

export const LinkText = styled.a`
  color: #CCCCCC;
  font-weight: 300;
  text-decoration: none;
  font-size: 14px;
  font-family: 'Outfit';
  display: flex;
  align-items: center;
  gap: 10px;
  transition: color 0.2s;

  &:hover { color: #FFC100; }
`